import axios, { AxiosError } from 'axios'
import { AppStatus } from '~concierge/types/IdentityTypes'
import { useIdentityStore } from '~conciergeUiCommons/store/identityStore'

export const BASE_API_PATH = '/api/alfred/forms'
export const BASE_API_PATH_EVENT = '/api/alfred/forms'

export class IdentityService {
  private static appStatus: AppStatus

  static async fetchAppStatus(): Promise<AppStatus> {
    if (!this.appStatus) {
      try {
        const isEvent = useIdentityStore().service === 'conciergeEvent'
        const url = isEvent ? BASE_API_PATH_EVENT : BASE_API_PATH
        const response = await axios.get(url + '/status')
        this.appStatus = response.data as AppStatus
      } catch (error: unknown | Error | AxiosError) {
        throw error
      }
    }
    return this.appStatus
  }

  static async getAppStatus(): Promise<AppStatus> {
    if (!this.appStatus) {
      this.appStatus = await this.fetchAppStatus()
    }
    return this.appStatus
  }
}
